import { createActionCreator } from "deox";

import { IProgramVersionSummaryModel } from "../../../types/types";
export const digitalProgramsByServicesError = createActionCreator("digitalProgramsByServicesError");
export const digitalProgramsByServicesLoading = createActionCreator("digitalProgramsByServicesLoading");

export const digitalProgramsByServicesReset = createActionCreator("digitalProgramsByServicesReset");
export const digitalProgramsByServicesSuccess = createActionCreator(
  "digitalProgramsByServicesSuccess",
  (resolve) => (services: IProgramVersionSummaryModel[]) => resolve(services)
);
